export default __webpack_public_path__ + "static/media/Raven's Feast.d1895605.jpg";